<template>
	<div class="footer">
		<div class="pub_div links">
			<div class="left">
				
				<div class="item" v-for="(item, index) in infoList" :key="index">
					<h3>{{item.TypeName}}</h3>
					<ul>
						<li v-for="(x, y) in item.DataList"><a :href="'/'+language+'/about?Id='+x.Id">{{x.Title}}</a></li>
					</ul>
				</div>
				
				<div class="item">
					<h3>联系我们</h3>
					<ul>
						<li class="telphone">1-808-921-9999</li>
						<li class="email"><a href="mailto:info@hawaiiglobalholiday.com">info@hawaiiglobalholiday.com</a></li>
					</ul>
				</div>
			</div>
			<div class="right">
				<div class="item">
					<img src="@/assets/images/hgh_footer_qrcode.png">
					<h5>Shirley Yang</h5>
				</div>
			</div>
		</div>
		<div class="pub_div copyright">
			Copyright©1999-2026, Hawaiiglobalholiday.com All rights reserved.
		</div>
	</div>
</template>

<script>
	import {
		getInfoList
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'FooterPage',
		data() {
			return {
				language: 'cn', //语言版本				
				infoList: [],	//数据列表				
			}
		},
		created() {
			this.getInfoList()
		},
		methods: {
			//获取列表
			async getInfoList() {
				const {
					data: res
				} = await getInfoList(this.language)
				if (res.errcode === 0) {
					this.infoList = res.data
				} else {
					this.$message.error(res.errmsg);
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.footer {
		width: 100%;
		// height: 310px;
		margin-top: 40px;
		padding: 40px 0 20px 0;
		box-sizing: border-box;
		background-color: #EFF4FC;
		background-image: url(@/assets/images/hgh_footer_bg.png);
		background-position: center;
		background-size: auto 100%;

		.links {
			display: flex;
			justify-content: space-between;
			padding: 0 30px;
			box-sizing: border-box;

			.left {
				display: flex;
				justify-content: left;
				
				.item {
					margin-right: 150px;
					
					h3 {
						font-size: 18px;
						font-weight: 500;
					}
					
					ul {
						margin-top: 14px;
					}
					
					li {
						font-size: 15px;
						font-weight: 400;
						padding: 6px 0;
					}
					li.telphone {
						background-image: url(@/assets/images/hgh_footer_telphone.png);
						background-position: left;
						background-size: 16px 16px;
						background-repeat: no-repeat;
						padding-left: 24px;
					}
					li.email {
						background-image: url(@/assets/images/hgh_footer_email.png);
						background-position: left;
						background-size: 16px 16px;
						background-repeat: no-repeat;
						padding-left: 24px;
					}
				}
			}

			.right {
				.item {
					width: 120px;
					text-align: center;
					
					img {
						width: 100%;
						display: block;
					}
					
					h5 {
						margin-top: 6px;
						font-size: 14px;
						font-weight: 500;
					}
				}
			}
		}

		.copyright {
			border-top: #CBD7E9 solid 1px;
			margin-top: 20px;
			padding-top: 20px;
			color: #333;
			text-align: center;
			font-size: 15px;
		}
	}
</style>